import React from 'react';

import type { NetworkMapClonotype } from './networkMap.utils';

/**
 * Shared network-map clonotype data.
 *
 * `useNetworkMapClonotypes` fetches nodes + cells and runs an O(cells + nodes) transform into
 * NetworkMapClonotype[]. Three components need that result (ControlBar, NetworkMapVisualization,
 * and the mini-graph map on the AB table), so rather than each calling the hook — which would
 * re-run the transform three times — AntibodyAnalysisPage calls it once and shares the value here.
 */
export interface NetworkMapClonotypesValue {
  clonotypes: NetworkMapClonotype[];
  byClonotypeId: Map<number, NetworkMapClonotype>;
  isLoading: boolean;
}

const EMPTY_VALUE: NetworkMapClonotypesValue = { clonotypes: [], byClonotypeId: new Map(), isLoading: false };

const NetworkMapClonotypesContext = React.createContext<NetworkMapClonotypesValue>(EMPTY_VALUE);

export const NetworkMapClonotypesProvider = NetworkMapClonotypesContext.Provider;

export function useNetworkMapClonotypesContext(): NetworkMapClonotypesValue {
  return React.useContext(NetworkMapClonotypesContext);
}
